<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">Chyba přihlášení</div>
    </div>

    <div class="hypo-dialog-content">
        <p>
            Tento telefon nebo email je, na vaši žádost, zablokovaný a nelze jej použít pro přihlášení. Pokud si
            myslíte, že jde o chybu, napište nám na
            <a href="mailto:info@hyponamiru.cz">info&#64;hyponamiru.cz</a>.
        </p>
    </div>

    <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-center">
        <button
            (click)="dialogRef.close()"
            class="btn btn-lg orange info-text-dialog-button"
            [attr.data-testid]="'blacklist-dialog-button-cancel'"
            mat-button
            type="button">
            Zavřít
        </button>
    </div>
</mat-dialog-content>
